module.exports = "/_next/static/images/Kingspan-c58ce126dd84a910184affe8544b7252.svg";